import React, { Component } from "react";
import { Button, Tooltip, Icon } from "antd";
import Fetch from "../../../common/Fetch";
import API_URL from "../../../common/url";
import dictCache from '../../../common/dictCache';
import Filter from "./Filter";
import TableC from "../../basicElement/TableC";
import addToDownloadSite from '../../common/addToDownloadSite';
import format from "../../shared/format";
import SideNav from "../SideNav";
import moment from "moment";
import Exportcuredata from './Exportcuredata'

class FinanceIncomeReport extends Component {
    constructor(props) {
        super(props);
        const searchParams = {
            startOper: "EQ",
            endOper: "EQ",
        };
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: { ...searchParams },
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            columnsTitle: [],
            businessList: [],
            contractTypeList: [],
            signingUnitOptions: [],
            belongingToUnitOptions: [],
            endMonth: "",
            startMonth: "",
            operable: false,
        };
    }

    componentDidMount() {
        this.querySigningUnit();
        this.queryBelongingToUnit();
        this.loadTypeConfigureList();
        this.queryWithLevelByParams();
        this.queryFixedLineTime();
        //this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate).then(cb);
        }, res => {
            const { date,month,year } = res;
            const { searchParams } = this.state;
            searchParams.date = moment(date).format("YYYY-MM");
            searchParams.month = month;
            searchParams.year = year;
            this.setState({ searchParams }
                , () => {
                    this.loadData();
                }
                );
        });
    }

    querySigningUnit = () => {
        dictCache.getDict('UNIT_SIGNING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfSigningList, {
                offset: 1,
                limit: 999,
            }).then(cb);
        }, (res) => {
            const { datas = [] } = res;
            const signingUnitOptions = (datas || []).map((i) => ({
                value: i.unitOfSigningId,
                label: i.unitOfSigningName,
            }));
            this.setState({ signingUnitOptions });
        });
    };

    queryBelongingToUnit = () => {
        dictCache.getDict('UNIT_BELONGING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfBelongingList, {
                offset: 1,
                limit: 999,
            }).then(cb);
        }, (res) => {
            const { datas = [] } = res;
            const belongingToUnitOptions = (datas || []).map((i) => ({
                value: i.unitOfBelongingId,
                label: i.unitOfBelongingName,
            }));
            this.setState({ belongingToUnitOptions });
        });
    };

    queryFixedLineTime = () => {
        Fetch.post(API_URL.finance.queryFixedLineTime).then((res) => {
            const { data } = res;
            if (!data || data.length === 0) {
                this.setState({ operable: false });
                return;
            }
            const { searchParams } = this.state;
            const startMonth = moment(
                format("month", data[0].year, data[0].month)
            ).format("YYYY-MM");
            const endMonth = moment(
                format(
                    "month",
                    data[data.length - 1].year,
                    data[data.length - 1].month
                )
            ).format("YYYY-MM");
            //searchParams.date = endMonth;
            this.setState(
                {
                    endMonth,
                    startMonth,
                    searchParams,
                    operable: true,
                    curParams: searchParams,
                },
                // () => {
                //     this.loadData();
                // }
                () => {
                    this.queryEffectiveDate();
                }
            );
        });
    };

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList).then(cb);
        }, (res) => {
            const { contractTypeList } = res;
            this.setState({ contractTypeList });
        });
    };

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS_filterAroRecruit', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: "LINE_OF_BUSINESS",
                filter:"filterAroRecruit",
            }).then(cb);
        }, (res) => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    };

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const { areaCity } = curParams;
        const params = this.splitParams(curParams);
        (areaCity || []).forEach(
            (i) => (params[`params[${i.props.title}]`] = i.key)
        );
        Fetch.post(API_URL.finance.queryInvSiteRecordInfoList, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...params,
        })
            .then((res) => {
                const { datas, totalCount } = res;
                const { handAmounts, yearAmounts } =
                    datas && datas.length ? datas[0] : {};
                pagination.total = totalCount;
                const columnsTitle = [];
                (handAmounts || []).forEach((i) => {
                    const { yearNum, monthNum } = i;
                    if (monthNum > 0) {
                        columnsTitle.push({
                            title: `${yearNum}${
                                monthNum < 10 ? `0${monthNum}` : monthNum
                            }`,
                            dataIndex: `${yearNum}${monthNum}`,
                            key: `${yearNum}${monthNum}`,
                            width: 80,
                        });
                    }
                });
                (yearAmounts || []).forEach((i) => {
                    const { yearNum } = i;
                    columnsTitle.push({
                        title: `${yearNum}在手订单额合计`,
                        dataIndex: `${yearNum}`,
                        key: `${yearNum}`,
                        width: 80,
                    });
                });
                datas.forEach((item) => {
                    const { handAmounts, yearAmounts } = item;
                    (handAmounts || []).forEach((i) => {
                        const { yearNum, monthNum, amount } = i;
                        if (monthNum > 0) {
                            item[`${yearNum}${monthNum}`] = format(
                                "money",
                                amount
                            );
                        }
                    });
                    (yearAmounts || []).forEach((i) => {
                        const { yearNum, amount } = i;
                        item[`${yearNum}`] = format("money", amount);
                    });
                });
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                    columnsTitle,
                });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ loading: false });
            });
    };

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState(
            {
                pagination,
                curParams: { ...searchParams },
            },
            () => {
                this.loadData();
            }
        );
    };

    export = () => {
        const { sortParams, curParams } = this.state;
        const { areaCity } = curParams;
        const params = this.splitParams(curParams);
        (areaCity || []).forEach(
            (i) => (params[`params[${i.props.title}]`] = i.key)
        );
        const url = API_URL.finance.exportInvSiteRecordInfoList;
        addToDownloadSite({ ...sortParams, ...params }, url, 'INV_SITE_RECORD');
    };

    showExportcuredata(){
        this.Exportcuredata.showModal()
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== "object" || value === null) {
                result[key] = value;
            }
        }
        return result;
    };

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    };

    handleStringLinefeed = (text) => {
        const arr = (text || "").split(",");
        const result = arr.map((item, index) => {
            return (
                <span key={index}>
                    {item}
                    {index < arr.length - 1 ? "," : ""}
                    <br />
                </span>
            );
        });
        return result;
    };

    getRender = (key) => (text, record) => (record[key] ? record[key] : text);

    getColumns = () => {
        const { columnsTitle } = this.state;
        const columns = [
            {
                title: "中心收入确认时间",
                dataIndex: "date",
                key: "date",
                fixed: "left",
                width: 80,
                render: (text, record) => {
                    const { recordYear, recordMonth } = record;
                    return `${recordYear}${
                        recordMonth < 10 ? `0${recordMonth}` : recordMonth
                    }`;
                },
            },
            {
                title: "区域",
                dataIndex: "areaName",
                key: "areaName",
                fixed: "left",
                width: 80,
            },
            {
                title: "省份",
                dataIndex: "provinceName",
                key: "provinceName",
                fixed: "left",
                width: 80,
            },
            {
                title: "城市",
                dataIndex: "cityName",
                key: "cityName",
                fixed: "left",
                width: 80,
            },
            {
                title: "县级行政区（如无则默认为上级行政单位）",
                dataIndex: "countyName",
                key: "countyName",
                fixed: "left",
                width: 80,
            },
            {
                title: "中心名称",
                dataIndex: "siteName",
                key: "siteName",
                fixed: "left",
                width: 160,
            },
            {
                title: "院区",
                dataIndex: "courtyardArea",
                key: "courtyardArea",
                fixed: "left",
                width: 80,
            },
            {
                title: "医院主管",
                dataIndex: "hospitalDirector",
                key: "hospitalDirector",
                width: 100,
                render: (text, record) =>
                    format(
                        "joint",
                        text,
                        record.hospitalDirectorCode,
                        "roundBrackets"
                    ),
            },
            {
                title: "医院主管上级",
                dataIndex: "hospitalDirectorLeader",
                key: "hospitalDirectorLeader",
                width: 100,
                render: (text, record) =>
                    format(
                        "joint",
                        text,
                        record.hospitalDirectorLeaderCode,
                        "roundBrackets"
                    ),
            },
            {
                title: "科室leader",
                dataIndex: "jsChargeUserNameCode",
                key: "jsChargeUserNameCode",
                width: 100,
                
            },
            {
                title: "科室",
                dataIndex: "departmentName",
                key: "departmentName",
                width: 100,
            },
            {
                title: "JDE主项目号",
                dataIndex: "jdeMainCode",
                key: "jdeMainCode",
                width: 100,
            },
            {
                title: "项目简称",
                dataIndex: "investigationName",
                key: "investigationName",
                width: 120,
            },
            {
                title: "JDE项目号",
                dataIndex: "jdeCode",
                key: "jdeCode",
                width: 100,
            },
            {
                title: "计划FTE预估",
                dataIndex: "planFteEstimated",
                key: "planFteEstimated",
                width: 85,
            },
            {
                title: "计划入组例数",
                dataIndex: "planRandom",
                key: "planRandom",
                width: 90,
            },
            {
                title: "计划标准访视数量",
                dataIndex: "planStandardVisit",
                key: "planStandardVisit",
                width: 80,
            },
            {
                title: "合同是否签署完成",
                dataIndex: "contractIsSigned",
                key: "contractIsSigned",
                width: 80,
            },
            {
                title: "合同新增时间",
                dataIndex: "contractCreateTime",
                key: "contractCreateTime",
                width: 100,
            },
            {
                title: "业务线",
                dataIndex: "lineOfBusinessName",
                key: "lineOfBusinessName",
                width: 80,
            },
            {
                title: "执行业务线二级分类",
                dataIndex: "secondLineNames",
                key: "secondLineNames",
                width: 100,
            },
            {
                title: "项目阶段",
                dataIndex: "investigationStageNames",
                key: "investigationStageNames",
                width: 80,
            },
            {
                title: "合同性质",
                dataIndex: "contractNature",
                key: "contractNature",
                width: 80,
            },
            {
                title: "客户全名",
                dataIndex: "customerCompany",
                key: "customerCompany",
                width: 120,
            },
            {
                title: "PM工号",
                dataIndex: "pmEmployeeCode",
                key: "pmEmployeeCode",
                width: 80,
            },
            {
                title: "PM姓名",
                dataIndex: "pmUserCompellation",
                key: "pmUserCompellation",
                width: 80,
            },
            {
                title: "PM主管工号",
                dataIndex: "pmLeaderEmployeeCode",
                key: "pmLeaderEmployeeCode",
                width: 85,
            },
            {
                title: "PM主管姓名",
                dataIndex: "pmLeaderUserCompellation",
                key: "pmLeaderUserCompellation",
                width: 85,
            },
            {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            },
            {
                title: "BD工号",
                dataIndex: "bdCodes",
                key: "bdCodes",
                width: 80,
                render: this.handleStringLinefeed,
            },
            {
                title: "BD姓名",
                dataIndex: "bdNames",
                key: "bdNames",
                width: 80,
                render: this.handleStringLinefeed,
            },
            {
                title: "BA工号",
                dataIndex: "baCodes",
                key: "baCodes",
                width: 100,
                render: this.handleStringLinefeed,
            },
            {
                title: "BA姓名",
                dataIndex: "baNames",
                key: "baNames",
                width: 100,
                render: this.handleStringLinefeed,
            },
            {
                title: "项目分类",
                dataIndex: "investigationType",
                key: "investigationType",
                width: 100,
            },
            {
                title: "项目分期",
                dataIndex: "byStageNames",
                key: "byStageNames",
                width: 80,
            },
            {
                title: "项目领域",
                dataIndex: "invAreaShow",
                key: "invAreaShow",
                width: 100,
            },
            {
                title: "疾病",
                dataIndex: "diseaseName",
                key: "diseaseName",
                width: 80,
            },
            {
                title: "计收入确认方式",
                dataIndex: "contractTypeValue",
                key: "contractTypeValue",
                width: 80,
            },
            {
                title: "合同开始时间",
                dataIndex: "contractStartTime",
                key: "contractStartTime",
                width: 90,
            },
            {
                title: "合同结束时间",
                dataIndex: "contractEndTime",
                key: "contractEndTime",
                width: 90,
            },
            {
                title: "实际单月消耗FTE",
                dataIndex: "actualFte",
                key: "actualFte",
                width: 80,
            },
            {
                title: "实际单月入组例数",
                dataIndex: "actualRandom",
                key: "actualRandom",
                width: 80,
            },
            {
                title: "实际单月确认标准访视数量",
                dataIndex: "actualStandardVisit",
                key: "actualStandardVisit",
                width: 80,
            },{
                title: (
                    <span>
                        当年累计入组例数
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'上年度12/26~本月25号随机入组数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "yearActualTotalRandom",
                key: "yearActualTotalRandom",
                width: 80,
            },{
                title: (
                    <span>
                        当年累计标准访视数量
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'上年度12/26~本月25号标准访视数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "yearActualTotalStandardVisit",
                key: "yearActualTotalStandardVisit",
                width: 80,
            },
            {
                title: "实际累计消耗FTE",
                dataIndex: "actualTotalFte",
                key: "actualTotalFte",
                width: 80,
            },
            {
                title: (
                    <span>
                        历年累计入组例数
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月25号随机入组数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "actualTotalRandom",
                key: "actualTotalRandom",
                width: 80,
            },
            {
                title: (
                    <span>
                        历年累计标准访视数量
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月25号标准访视数量'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "actualTotalStandardVisit",
                key: "actualTotalStandardVisit",
                width: 80,
            },
            {
                title: "合同中是否明标合同金额",
                dataIndex: "contractIsSpecifiesAmount",
                key: "contractIsSpecifiesAmount",
                width: 90,
            },
            {
                title: "合同发票税率",
                dataIndex: "invoiceRate",
                key: "invoiceRate",
                width: 95,
            },
            {
                title: "合同FTE 单价（不含税）",
                dataIndex: "fteUnitPriceNoTax",
                key: "fteUnitPriceNoTax",
                width: 120,
            },
            {
                title: "合同额含税/人民币",
                dataIndex: "cnyContractAmount",
                key: "cnyContractAmount",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "合同实报实销（不含税）/人民币",
                dataIndex: "cnyActualExpenseFee",
                key: "cnyActualExpenseFee",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "合同实报实销税费/人民币",
                dataIndex: "cnyActualFee",
                key: "cnyActualFee",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "服务费含税/人民币",
                dataIndex: "cnyServiceFeeIncludeTax",
                key: "cnyServiceFeeIncludeTax",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "服务费不含税/人民币",
                dataIndex: "cnyServiceFeeNoTax",
                key: "cnyServiceFeeNoTax",
                width: 140,
                render: text => format('money', text), 
            },
            {
                title: "项目计划开始时间",
                dataIndex: "invPlanBeginTimeStr",
                key: "invPlanBeginTimeStr",
                width: 80,
            },
            {
                title: "项目计划结束时间",
                dataIndex: "invPlanEndTimeStr",
                key: "invPlanEndTimeStr",
                width: 80,
            },
            {
                title: "当月开票金额（含税）/人民币",
                dataIndex: "cnyCurrentMonthInvoice",
                key: "cnyCurrentMonthInvoice",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "累计开票金额（含税）/人民币",
                dataIndex: "cnyTotalMonthInvoice",
                key: "cnyTotalMonthInvoice",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "累计开票百分比",
                dataIndex: "totalInvoicePercent",
                key: "totalInvoicePercent",
                width: 80,
            },
            {
                title: (
                    <span>
                        累计收入不含税/人民币
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'项目开始~本月收入不含税/人民币'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "cnyTotalIncomeNoTax",
                key: "cnyTotalIncomeNoTax",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "累计上月收入不含税/人民币",
                dataIndex: "cnyTotalLastMonthIncomeNoTax",
                key: "cnyTotalLastMonthIncomeNoTax",
                width: 120,
                render: text => format('money', text), 
            },{
                title: "当月服务费收入不含税/人民币",
                dataIndex: "cnyCurrentMonthIncomeNoTax",
                key: "cnyCurrentMonthIncomeNoTax",
                width: 120,
                render: text => format('money', text), 
            },{
                title: (
                    <span>
                        当年服务费收入不含税/人民币
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'本年度1月~本月收入不含税/人民币'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: "cnyCurrentYearIncomeNoTax",
                key: "cnyCurrentYearIncomeNoTax",
                width: 120,
                render: text => format('money', text), 
            },
            {
                title: "在手订单额（不含税）",
                dataIndex: "ordersInHandAmountNoTax",
                key: "ordersInHandAmountNoTax",
                width: 140,
                render: text => format('money', text), 
            },
        ];
        columns.push(...columnsTitle);
        columns.push({
            title: "在手订单额余额(不含税)/人民币",
            dataIndex: "ordersInHandAmountRemainderNoTax",
            key: "ordersInHandAmountRemainderNoTax",
            width: 120,
            render: text => format('money', text), 
        });
        return columns;
    };

    handleTableChange = (params) => {
        this.setState(
            {
                ...params,
            },
            () => {
                this.loadData();
            }
        );
    };

    render() {
        const {
            data,
            loading,
            pagination,
            searchParams,
            sortParams,
            businessList,
            contractTypeList,
            signingUnitOptions,
            belongingToUnitOptions,
            endMonth,
            startMonth,
            operable,
        } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="centerIncomeReport" />
                <div className="main">
                    <Filter
                        operable={operable}
                        expandHeight={160}
                        search={this.search}
                        params={searchParams}
                        endMonth={endMonth}
                        startMonth={startMonth}
                        businessList={businessList}
                        contractTypeList={contractTypeList}
                        onChange={this.handleFilterChange}
                        signingUnitOptions={signingUnitOptions}
                        belongingToUnitOptions={belongingToUnitOptions}
                        buttons={[
                            <Button
                                key="export"
                                type="primary"
                                disabled={!operable}
                                onClick={this.export}
                            >
                                导出
                            </Button>,
                            <Button key="Exportcuredata" type="primary"  onClick={() => this.showExportcuredata()}>导出固化数据</Button>
                        ]}
                    />
                    <Exportcuredata 
                        searchParams={searchParams}
                        ref={el => this.Exportcuredata = el}/>
                    <TableC
                        data={data}
                        scrollY={480}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        rowKey="investigationJdeContractRecordId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
            </div>
        );
    }
}

export default FinanceIncomeReport;



// WEBPACK FOOTER //
// ./src/components/financeManagement/centerIncomeReport/index.js